export default "__VITE_ASSET__DxU$gljW__"